<template>
  <v-btn v-bind="$props" v-on="$listeners"
    :data-cy="dataCy"
  >
    <template v-slot:loader>
      <ProgressCircularTimeout />
    </template>
    <slot />
  </v-btn>
</template>

<script>
import { VBtn } from 'vuetify/lib';
import ProgressCircularTimeout from './ProgressCircularTimeout.vue';

export default {
  name: 'ButtonProgress',
  extends: VBtn,
  components: {
    ProgressCircularTimeout,
  },
  props: {
    /** data-cy attribute for button
     */
    dataCy: {
      type: String,
      default: 'button-progress',
    },
  },
};
</script>
